export const locationsMock = [
    {
        id: 1,
        name: '1101AK Amsterdam',
        schedule: {
            mon: {from: 8, to: 20},
            tue: {from: 10, to: 22},
            wed: {from: 9, to: 20},
            thu: {from: 9, to: 20},
            fri: {from: 9, to: 20},
            sat: {from: 12, to: 19},
            sun: {from: 11, to: 20},
        },
        isAlwaysOpen: false,
        locationPromo: 'KAV2GO',
        amountOfVehicles: 5
    }
];